module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/es-ga-405f191245cb5d0085d789f338a16d67.svg";